import Head from "next/head";
import Layout from "../components/layout";
import { Spacer, Text } from "@nextui-org/react";

const Home = () => {
  return (
    <>
      <Head>
        <title>Editorland | About Editorland</title>
      </Head>
      <Layout>
        <Text h1>Editorland</Text>
        <Text b>Submission management for everyone.</Text>
        <Spacer y={0.5} />
        <Text>
          Editorland is a totally-free submission management tool that's
          provided as a service to literary, scientific, or other subject-matter
          journals. Founded in 2017 for{" "}
          <a href="https://failbetter.com">
            <i>failbetter</i>
          </a>{" "}
          to be able to accept fiction and poetry submissions without needing to
          spend a ton of cash, we at Editorland want to help support the
          literary and scientific community by paying it forward.
        </Text>
        <Spacer y={0.5} />
        <Text>
          This version of Editorland is in an open beta. There may be bugs! If
          you find any, please contact{" "}
          <a href="mailto:feedback@editorland.com">feedback@editorland.com</a>.
        </Text>
        <Spacer y={0.5} />
        <Text>
          If you have any other feedback, please contact{" "}
          <a href="mailto:editors@editorland.com">editors@editorland.com</a>.
          Please be sure to only write about the submission management platform;
          we cannot respond to queries about specific journals.
        </Text>
      </Layout>
    </>
  );
};

export default Home;
